import { ServiceRateTypeEnum } from "@gap/backend/app-services/services/models/ServiceRateTypesDto";

export const defaultStartingPriceRate: ServiceRateTypeEnum = 'Per month'